import { put, select } from 'redux-saga/effects';
import { newMessageEvent } from 'rdx/modules/messages/slice';
import makeRequest from 'rdx/utils/makeRequest';
import { putErrorActions } from 'rdx/utils/putErrorActions';
import { requestReagents } from 'rdx/modules/reagents/slice';
import { getCurrentOrgSlug } from 'rdx/modules/organization/slice';
import { getSessionAction } from 'rdx/modules/auth/slice';
import { PayloadActionWithGenericPayload } from 'types/redux-types';
import Action from 'lib/jsonApi/Action';

function* patchReagent(rdxAction: PayloadActionWithGenericPayload & { payload: { import_type?: 'custom' | 'bd' } }) {
  const { action, onSuccess, import_type, params } = rdxAction.payload;
  const input = { ...params };
  const { success, error, data } = yield makeRequest.action(action, input);
  if (success && data) {
    const reagentsAction: Action = yield select(getSessionAction('reagents'));
    const slug: string | undefined = yield select(getCurrentOrgSlug);
    yield put(requestReagents({
      action: reagentsAction,
      params: { organization_id: slug, import_type: import_type ?? 'custom' },
    }));
    if (onSuccess) {
      onSuccess(data);
    }
    yield put(newMessageEvent({ text: 'Reagent Updated' }));
  } else {
    yield* putErrorActions({ error, rdxAction, onSuccess });
  }
  return null;
}

export default patchReagent;
